/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Email_PlaceholderInputs */

const en_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const ar_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني`)
};

const bn_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইমেইল`)
};

const de_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const es_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico`)
};

const fr_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const pt_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const zh_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件`)
};

const tr_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta`)
};

const ru_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`электронная почта`)
};

const pl_form_email_placeholder = /** @type {(inputs: Form_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Form_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_email_placeholder = /** @type {((inputs?: Form_Email_PlaceholderInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Email_PlaceholderInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_email_placeholder(inputs)
	if (locale === "bn") return bn_form_email_placeholder(inputs)
	if (locale === "de") return de_form_email_placeholder(inputs)
	if (locale === "es") return es_form_email_placeholder(inputs)
	if (locale === "fr") return fr_form_email_placeholder(inputs)
	if (locale === "pt") return pt_form_email_placeholder(inputs)
	if (locale === "zh") return zh_form_email_placeholder(inputs)
	if (locale === "tr") return tr_form_email_placeholder(inputs)
	if (locale === "ru") return ru_form_email_placeholder(inputs)
	if (locale === "pl") return pl_form_email_placeholder(inputs)
	return en_form_email_placeholder(inputs)
});